import React, { useContext, useState, useEffect } from "react";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
// import {  Button, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import { IconButton } from "@mui/material";
import { Groups, SaveAlt } from "@mui/icons-material";

import CallIcon from "@material-ui/icons/Call";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import FilterListIcon from "@material-ui/icons/FilterList";
import ClearIcon from "@material-ui/icons/Clear";
import SendIcon from "@material-ui/icons/Send";
import RefreshIcon from "@material-ui/icons/Refresh";
import MessageIcon from "@material-ui/icons/Message";
import AccessAlarmIcon from "@material-ui/icons/AccessAlarm";
import TimerIcon from "@material-ui/icons/Timer";
import * as XLSX from "xlsx";
import CheckCircleOutlineIcon from "@material-ui/icons/RecordVoiceOver";
import ErrorOutlineIcon from "@material-ui/icons/RecordVoiceOver";

import { grey, blue } from "@material-ui/core/colors";
import { toast } from "react-toastify";

import MainContainer from "../../components/MainContainer";
import TabPanel from "../../components/TabPanel";
import TableAttendantsStatus from "../../components/Dashboard/TableAttendantsStatus";
import { isArray } from "lodash";

import { AuthContext } from "../../context/Auth/AuthContext";

import useDashboard from "../../hooks/useDashboard";
import useContacts from "../../hooks/useContacts";
import useMessages from "../../hooks/useMessages";
import { ChatsUser } from "./ChartsUser";

import Filters from "./Filters";
import ChatMoments from "../Moments";
import FloupDashboard from "../FloupDashboard";
import { isEmpty } from "lodash";
import moment from "moment";
import { ChartsDate } from "./ChartsDate";
import Reports from "../Reports";
import {
  Avatar,
  Button,
  Card,
  CardContent,
  Container,
  Stack,
  SvgIcon,
  Tab,
  Tabs,
  LinearProgress,
  Box,
} from "@mui/material";
import { i18n } from "../../translate/i18n";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import ForbiddenPage from "../../components/ForbiddenPage";
import { ArrowDownward, ArrowUpward } from "@material-ui/icons";
import { te } from "date-fns/locale";

const useStyles = makeStyles((theme) => ({
  overline: {
    fontSize: "0.9rem",
    fontWeight: 700,
    color: theme.palette.text.secondary,
    letterSpacing: "0.5px",
    lineHeight: 2.5,
    textTransform: "uppercase",
    fontFamily: "'Inter', sans-serif'",
  },
  h4: {
    fontFamily: "'Inter', sans-serif'",
    fontWeight: 500,
    fontSize: "2rem",
    lineHeight: 1,
    color: theme.palette.text.primary,
  },
  selected: {},
  tab: {
    minWidth: "auto",
    width: "auto",
    padding: theme.spacing(0.5, 1),
    borderRadius: 4,
    transition: "0.3s",
    borderWidth: "1px",
    borderStyle: "solid",
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    color: theme.mode === "dark" ? "#FFF !important" : "#000 !important",
    opacity: "1 !important",

    [theme.breakpoints.down("lg")]: {
      fontSize: "0.9rem",
      padding: theme.spacing(0.4, 0.8),
      marginRight: theme.spacing(0.4),
      marginLeft: theme.spacing(0.4),
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "0.8rem",
      padding: theme.spacing(0.3, 0.6),
      marginRight: theme.spacing(0.3),
      marginLeft: theme.spacing(0.3),
    },
    "&:hover": {
      backgroundColor: "rgba(6, 81, 131, 0.3)",
    },
    "&.Mui-selected": {
      color: theme.palette.primary.contrastText + " !important",
      backgroundColor: theme.palette.primary.main + " !important",
    },
  },
  tabIndicator: {
    borderWidth: "2px",
    borderStyle: "solid",
    height: 6,
    bottom: 0,
    color:
      theme.palette.mode === "light"
        ? theme.palette.primary.main
        : theme.palette.primary.contrastText,
  },
  container: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  nps: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.padding,
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    height: 240,
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  cardAvatar: {
    fontSize: "55px",
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  cardTitle: {
    fontSize: "18px",
    color: theme.palette.primary.main,
  },
  cardSubtitle: {
    color: theme.palette.text.secondary,
    fontSize: "14px",
  },
  alignRight: {
    textAlign: "right",
  },
  fullWidth: {
    width: "100%",
  },
  selectContainer: {
    width: "100%",
    textAlign: "left",
  },
  iframeDashboard: {
    width: "100%",
    height: "calc(100vh - 64px)",
    border: "none",
  },
  customFixedHeightPaperLg: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
  },
  sectionTitle: {
    fontSize: "1.5rem",
    fontWeight: 700,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
  },
  mainPaper: {
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
    ...theme.scrollbarStyles,
    backgroundColor: theme.palette.fancyBackground,
    borderRadius: "0px",
  },
  paper: {
    padding: theme.spacing(2),
    borderRadius: 4,
    backgroundColor: theme.mode === "light" ? "#f9f9f9" : "#273142",
    boxShadow: theme.shadows[1],
  },
  barContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  progressBar: {
    flex: 1,
    marginRight: theme.spacing(1),
    borderRadius: 4,
    height: 10,
  },
  progressLabel: {
    minWidth: 50,
    textAlign: "right",
    fontWeight: 500,
    color: theme.palette.mode === "light" ? theme.palette.text.secondary : theme.palette.text.primary,
  },
  infoCard: {
    padding: theme.spacing(2),
    textAlign: "center",
    borderRadius: 4,
    boxShadow: theme.shadows[1],
    backgroundColor: theme.mode === "light" ? "#f9f9f9" : "#273142",
    marginBottom: theme.spacing(2),
  }, statCard: {
    padding: theme.spacing(3),
    borderRadius: 4,
    boxShadow: theme.shadows[1],
    backgroundColor: theme.mode === "light" ? "#f9f9f9" : "#273142",
    minHeight: 140,
  },
  largeStatCard: {
    padding: theme.spacing(3),
    borderRadius: 4,
    backgroundColor: theme.mode === "light" ? "#f9f9f9" : "#273142",
    minHeight: 180,
    boxShadow: theme.shadows[1],
  },
  statIcon: {
    width: 56,
    height: 56,
    borderRadius: 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.mode === "light" ? "rgba(0,0,0,0.05)" : "rgba(255,255,255,0.08)",
  },
  badge: {
    padding: theme.spacing(0.5, 1.2),
    borderRadius: 4,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontWeight: 700,
    fontSize: "0.75rem",
  }, infoIcon: {
    fontSize: "2rem",
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
  },
}));

const Dashboard = () => {
  const theme = useTheme();
  const classes = useStyles();
  const [counters, setCounters] = useState({});
  const [attendants, setAttendants] = useState([]);
  const [filterType, setFilterType] = useState(1);
  const [period, setPeriod] = useState(0);
  const [dateFrom, setDateFrom] = useState(
    moment("1", "D").format("YYYY-MM-DD")
  );
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));
  const [loading, setLoading] = useState(false);
  const { find } = useDashboard();

  //FILTROS NPS
  const [tab, setTab] = useState("tempoReal");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedQueues, setSelectedQueues] = useState([]);

  let newDate = new Date();
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();
  let nowIni = `${year}-${month < 10 ? `0${month}` : `${month}`}-01`;

  let now = `${year}-${month < 10 ? `0${month}` : `${month}`
    }-${date < 10 ? `0${date}` : `${date}`}`;

  const [showFilter, setShowFilter] = useState(false);
  const [dateStartTicket, setDateStartTicket] = useState(nowIni);
  const [dateEndTicket, setDateEndTicket] = useState(now);
  const [queueTicket, setQueueTicket] = useState(false);
  const [fetchDataFilter, setFetchDataFilter] = useState(false);

  const { user } = useContext(AuthContext);

  const exportarGridParaExcel = () => {
    const ws = XLSX.utils.table_to_sheet(
      document.getElementById("grid-attendants")
    );
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "RelatorioDeAtendentes");
    XLSX.writeFile(wb, "relatorio-de-atendentes.xlsx");
  };

  var userQueueIds = [];

  if (user.queues && user.queues.length > 0) {
    userQueueIds = user.queues.map((q) => q.id);
  }

  useEffect(() => {
    let isMounted = true;

    async function firstLoad() {
      if (isMounted) {
        console.log('Executando firstLoad...');
        await fetchData();
      }
    }

    const timeoutId = setTimeout(() => {
      firstLoad();
    }, 500);

    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchDataFilter]);

  async function fetchData() {
    setLoading(true);
    console.log('Iniciando fetchData...');

    let params = {};

    // Construir parâmetros de filtro
    if (period > 0) {
      params = {
        days: period,
      };
      console.log('Usando filtro por dias:', period);
    } else {
      // Se não há período específico, usar as datas
      if (!isEmpty(dateStartTicket) && moment(dateStartTicket).isValid()) {
        params = {
          ...params,
          date_from: moment(dateStartTicket).format("YYYY-MM-DD"),
        };
        console.log('Data de início:', dateStartTicket);
      }

      if (!isEmpty(dateEndTicket) && moment(dateEndTicket).isValid()) {
        params = {
          ...params,
          date_to: moment(dateEndTicket).format("YYYY-MM-DD"),
        };
        console.log('Data de fim:', dateEndTicket);
      }
    }

    // Se nenhum parâmetro foi definido, usar período padrão de 30 dias
    if (Object.keys(params).length === 0) {
      console.log('Nenhum filtro definido, usando 30 dias como padrão');
      params = { days: 30 };
    }

    console.log('Parâmetros finais para busca:', params);

    try {
      const data = await find(params);
      console.log('Dados recebidos no componente:', data);

      // Garantir que counters sempre tenha valores válidos
      const safeCounters = data.counters || {};

      // Verificar especificamente o campo tickets
      console.log('Campo tickets recebido:', safeCounters.tickets);

      setCounters(safeCounters);

      if (isArray(data.attendants)) {
        setAttendants(data.attendants);
      } else {
        console.warn('Attendants não é um array:', data.attendants);
        setAttendants([]);
      }

      console.log('Estado atualizado - Counters:', safeCounters);
      console.log('Estado atualizado - Attendants:', data.attendants);

      // Log específico para verificar se o campo tickets está presente
      console.log('Valor de tickets no estado:', safeCounters.tickets);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
      toast.error('Erro ao carregar dados do dashboard');

      // Definir valores padrão em caso de erro
      setCounters({
        avgSupportTime: 0,
        avgWaitTime: 0,
        supportFinished: 0,
        supportHappening: 0,
        supportPending: 0,
        supportGroups: 0,
        leads: 0,
        activeTickets: 0,
        passiveTickets: 0,
        tickets: 0,
        waitRating: 0,
        withoutRating: 0,
        withRating: 0,
        percRating: 0,
        npsPromotersPerc: 0,
        npsPassivePerc: 0,
        npsDetractorsPerc: 0,
        npsScore: 0
      });
      setAttendants([]);
    } finally {
      setLoading(false);
    }
  }

  const handleSelectedUsers = (selecteds) => {
    const users = selecteds.map((t) => t.id);
    setSelectedUsers(users);
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  const handleRefresh = async () => {
    await fetchData();
  };

  function formatTime(minutes) {
    return moment().startOf("day").add(minutes, "minutes").format("HH[h] mm[m]");
  }

  const GetUsers = () => {
    let count;
    let userOnline = 0;
    attendants.forEach((user) => {
      if (user.online === true) {
        userOnline = userOnline + 1;
      }
    });
    count = userOnline === 0 ? 0 : userOnline;
    return count;
  };

  const GetContacts = (all) => {
    let props = {};
    if (all) {
      props = {};
    } else {
      props = {
        dateStart: dateStartTicket,
        dateEnd: dateEndTicket,
      };
    }
    const { count } = useContacts(props);
    return count;
  };

  const GetMessages = (all, fromMe) => {
    let props = {};
    if (all) {
      if (fromMe) {
        props = {
          fromMe: true,
        };
      } else {
        props = {
          fromMe: false,
        };
      }
    } else {
      if (fromMe) {
        props = {
          fromMe: true,
          dateStart: dateStartTicket,
          dateEnd: dateEndTicket,
        };
      } else {
        props = {
          fromMe: false,
          dateStart: dateStartTicket,
          dateEnd: dateEndTicket,
        };
      }
    }
    const { count } = useMessages(props);
    return count;
  };

  function toggleShowFilter() {
    setShowFilter(!showFilter);
  }

  return (
    <>
      {user.showDashboard !== "enabled" ? (
        <ForbiddenPage />
      ) : (
        <MainContainer>
          <Paper
            className={classes.mainPaper}
          // variant="outlined"
          >
            <Container maxWidth={false} className={classes.container} style={{ padding: '24px 48px', maxWidth: '100%', overflowX: 'hidden' }}>
              <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" mb={3}>
                <Box sx={{ textAlign: "center" }}>
                  <Typography className={classes.h4}>{i18n.t("dashboard.title")}</Typography>
                  <Typography className={classes.overline} style={{ textTransform: 'none', marginTop: 8 }}>
                    {i18n.t("dashboard.subtitle")}
                  </Typography>
                </Box>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<RefreshIcon />}
                  onClick={handleRefresh}
                  sx={{ mt: 2 }}
                >
                  {i18n.t("dashboard.buttons.refresh")}
                </Button>
              </Box>

              <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: 2 }}>
                <Tabs
                  value={tab}
                  onChange={handleChangeTab}
                  variant="scrollable"
                  scrollButtons="auto"
                  textColor="primary"
                  indicatorColor="primary"
                  TabIndicatorProps={{ className: classes.tabIndicator }}
                >
                  <Tab className={classes.tab} label={i18n.t("dashboard.tabs.realtime")} value="tempoReal" />
                  <Tab className={classes.tab} label={i18n.t("dashboard.tabs.panel")} value="painel" />
                  <Tab className={classes.tab} label={i18n.t("dashboard.tabs.followup")} value="followup" />
                  <Tab className={classes.tab} label={i18n.t("dashboard.tabs.reports")} value="relatorios" />
                </Tabs>
              </Box>

              <TabPanel value={tab} name="tempoReal">
                <Grid2 container spacing={2} className={classes.container} style={{ margin: 0, width: '100%' }}>
                  {/* FILTROS */}
                  <Grid2 xs={12} container justifyContent="flex-end">
                    <Button
                      onClick={toggleShowFilter}
                      color="primary"
                      startIcon={!showFilter ? <FilterListIcon /> : <ClearIcon />}
                    >
                      {showFilter ? i18n.t("dashboard.buttons.hideFilters") : i18n.t("dashboard.buttons.showFilters")}
                    </Button>
                  </Grid2>

                  {showFilter && (
                    <Grid2 item xs={12} style={{ marginBottom: "20px" }}>
                      <Filters
                        classes={classes}
                        setDateStartTicket={setDateStartTicket}
                        setDateEndTicket={setDateEndTicket}
                        dateStartTicket={dateStartTicket}
                        dateEndTicket={dateEndTicket}
                        setQueueTicket={setQueueTicket}
                        queueTicket={queueTicket}
                        fetchData={setFetchDataFilter}
                      />
                    </Grid2>
                  )}

                  {/* Indicadores Gerais */}
                  <Grid2 item xs={12} style={{ marginTop: '20px', paddingLeft: '4px' }}>
                    <Typography variant="h5" style={{ marginBottom: '10px', color: theme.palette.primary.main, textAlign: 'center' }}>{i18n.t("dashboard.sections.indicators")}</Typography>
                  </Grid2>
                  {[
                    { label: i18n.t("dashboard.indicators.totalToday"), value: counters.tickets || 0, icon: <CallIcon style={{ color: "#01BBAC" }} /> },
                    { label: i18n.t("dashboard.indicators.pending"), value: counters.supportPending || 0, icon: <HourglassEmptyIcon style={{ color: "#F7B500" }} /> },
                    { label: i18n.t("dashboard.indicators.inProgress"), value: counters.supportHappening || 0, icon: <Groups style={{ color: "#00A86B" }} /> },
                    { label: i18n.t("dashboard.indicators.finished"), value: counters.supportFinished || 0, icon: <CheckCircleIcon style={{ color: "#7C4DFF" }} /> },
                  ].map((indicator, index) => (
                    <Grid2 item xs={12} sm={6} md={3} key={index}>
                      <Paper className={classes.statCard}>
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                          <Box>
                            <Typography variant="subtitle2" color="textSecondary">
                              {indicator.label}
                            </Typography>
                            <Typography variant="h4" style={{ marginTop: 8 }}>
                              {indicator.value}
                            </Typography>
                          </Box>
                          <Box className={classes.statIcon}>{indicator.icon}</Box>
                        </Box>
                      </Paper>
                    </Grid2>
                  ))}

                  {[{
                    label: i18n.t("dashboard.indicators.onlineAttendants"),
                    value: `${GetUsers()}/${attendants.length}`,
                    caption: i18n.t("dashboard.indicators.onlineTeam"),
                    badge: `${Math.round((GetUsers() / (attendants.length || 1)) * 100)}%`,
                  },
                  {
                    label: i18n.t("dashboard.indicators.avgWaitTime"),
                    value: formatTime(counters.avgWaitTime),
                    caption: i18n.t("dashboard.indicators.waitMeta"),
                  },
                  {
                    label: i18n.t("dashboard.indicators.avgSupportTime"),
                    value: formatTime(counters.avgSupportTime),
                    caption: i18n.t("dashboard.indicators.supportMeta"),
                  }].map((stat, index) => (
                    <Grid2 item xs={12} md={4} key={index}>
                      <Paper className={classes.largeStatCard}>
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                          <Box>
                            <Typography variant="subtitle2" color="textSecondary">
                              {stat.label}
                            </Typography>
                            <Typography variant="h3" style={{ marginTop: 8 }}>
                              {stat.value}
                            </Typography>
                          </Box>
                          {stat.badge && (
                            <Box className={classes.badge}>{stat.badge}</Box>
                          )}
                        </Box>
                        <Typography variant="body2" color="textSecondary">
                          {stat.caption}
                        </Typography>
                      </Paper>
                    </Grid2>
                  ))}

                  {/* Pesquisa de Satisfação (NPS) */}
                  <Grid2 item xs={12} style={{ marginTop: '40px', paddingLeft: '4px', textAlign: 'center' }}>
                    <Typography variant="h5" style={{ marginBottom: '10px', color: theme.palette.primary.main }}>{i18n.t("dashboard.sections.satisfactionSurvey")}</Typography>
                  </Grid2>
                  {[
                    { key: "Score", label: i18n.t("dashboard.nps.score") },
                    { key: "Satisfeitos", label: i18n.t("dashboard.nps.satisfied") },
                    { key: "Neutros", label: i18n.t("dashboard.nps.neutral") },
                    { key: "Insatisfeitos", label: i18n.t("dashboard.nps.unsatisfied") }
                  ].map((item, index) => (
                    <Grid2 item xs={12} md={6} lg={3} key={index}>
                      <Paper className={classes.paper}>
                        <Box className={classes.barContainer}>
                          <Typography className={classes.progressLabel}>{item.label}</Typography>
                          <LinearProgress
                            variant="determinate"
                            value={
                              item.key === "Score" ? counters.npsScore || 0 :
                                item.key === "Satisfeitos" ? counters.npsPromotersPerc || 0 :
                                  item.key === "Neutros" ? counters.npsPassivePerc || 0 :
                                    counters.npsDetractorsPerc || 0
                            }
                            className={classes.progressBar}
                            style={{
                              backgroundColor:
                                item.key === "Satisfeitos" ? "#2EA85A" :
                                  item.key === "Neutros" ? "#F7EC2C" :
                                    item.key === "Insatisfeitos" ? "#F73A2C" : "#000",
                            }}
                          />
                          <Typography className={classes.progressLabel}>{
                            item.key === "Score" ? counters.npsScore || 0 :
                              item.key === "Satisfeitos" ? counters.npsPromotersPerc || 0 :
                                item.key === "Neutros" ? counters.npsPassivePerc || 0 :
                                  counters.npsDetractorsPerc || 0
                          }%</Typography>
                        </Box>
                      </Paper>
                    </Grid2>
                  ))}

                  {/* Informações de Atendimento */}
                  <Grid2 item xs={12} style={{ marginTop: '40px', paddingLeft: '4px' }}>
                    <Typography variant="h5" style={{ marginBottom: '10px', color: theme.palette.primary.main, textAlign: 'center' }}>{i18n.t("dashboard.sections.tickets")}</Typography>
                  </Grid2>
                  {[
                    { label: i18n.t("dashboard.attendances.total"), value: counters.tickets || 0, icon: <CallIcon style={{ color: '#01BBAC' }} /> },
                    { label: i18n.t("dashboard.attendances.awaitingRating"), value: counters.waitRating || 0, icon: <HourglassEmptyIcon style={{ color: '#47606e' }} /> },
                    { label: i18n.t("dashboard.attendances.withoutRating"), value: counters.withoutRating || 0, icon: <ErrorOutlineIcon style={{ color: '#8a2c40' }} /> },
                    { label: i18n.t("dashboard.attendances.withRating"), value: counters.withRating || 0, icon: <CheckCircleOutlineIcon style={{ color: '#805753' }} /> },
                  ].map((attInfo, index) => (
                    <Grid2 item xs={12} sm={6} md={3} key={index}>
                      <Paper className={classes.infoCard} style={{ height: '100%' }}>
                        <Box display="flex" alignItems="center">
                          {attInfo.icon}
                          <Box ml={2}>
                            <Typography variant="h6">{attInfo.value}</Typography>
                            <Typography variant="body2">{attInfo.label}</Typography>
                          </Box>
                        </Box>
                      </Paper>
                    </Grid2>
                  ))}

                  {/* Índice de Avaliação */}
                  <Grid2 item xs={12} style={{ marginTop: '40px', paddingLeft: '4px', paddingRight: '4px' }}>
                    <Typography variant="h5" style={{ marginBottom: '15px', color: theme.palette.primary.main, textAlign: "center" }}>{i18n.t("dashboard.sections.ratingIndex")}</Typography>
                    <Grid2 container alignItems="center" spacing={2}>
                      <Grid2 item xs={12} sm={2}>
                        <Paper className={classes.infoCard} style={{ textAlign: 'center', padding: '8px', backgroundColor: '#FFE3B3' }}>
                          <Typography variant="h5" style={{ color: '#F79009' }}>
                            {Number(counters.percRating / 100).toLocaleString(undefined, { style: 'percent' }) || "0%"}
                          </Typography>
                        </Paper>
                      </Grid2>
                      <Grid2 item xs={12} sm={10}>
                        <LinearProgress
                          variant="determinate"
                          value={counters.percRating || 0}
                          className={classes.progressBar}
                          style={{ backgroundColor: "#e0e0e0", height: 10, borderRadius: 4 }}
                        />
                      </Grid2>
                    </Grid2>
                  </Grid2>

                  {/* Tabela de Atendentes */}
                  <Grid2 item xs={12} style={{ marginTop: '40px', paddingLeft: '4px' }}>
                    <Typography variant="h5" style={{ marginBottom: '10px', color: theme.palette.primary.main, textAlign: "center" }}>{i18n.t("dashboard.sections.attendants")}</Typography>
                    <Paper className={classes.paper}>
                      <TableAttendantsStatus
                        attendants={attendants}
                        loading={loading}
                      />
                    </Paper>
                  </Grid2>

                  {/* Gráficos */}
                  <Grid2 container spacing={3} item xs={12}>
                    <Grid2 item xs={12} md={6}>
                      <Paper className={classes.paper} style={{ marginBottom: "16px" }}>
                        <ChatsUser />
                      </Paper>
                    </Grid2>
                    <Grid2 item xs={12} md={6}>
                      <Paper className={classes.paper}>
                        <ChartsDate />
                      </Paper>
                    </Grid2>
                  </Grid2>
                </Grid2>
              </TabPanel>

              <TabPanel value={tab} name="painel">
                <ChatMoments embedded={true} />
              </TabPanel>

              <TabPanel value={tab} name="followup">
                <FloupDashboard />
              </TabPanel>

              <TabPanel value={tab} name="relatorios">
                <Reports embedded={true} />
              </TabPanel>
            </Container>
          </Paper>
        </MainContainer>
      )}
    </>
  );
};

export default Dashboard;